import { CONFIG } from "../config.ts";

// A dropped poop. It remembers the tier of whoever dropped it and whether it's
// the Buddha's golden poop; the XP it grants is computed at eat-time (in Game)
// so pacing scales with the player's current stage.
export class Poop {
  x: number;
  y: number;
  tier: number;
  radius: number;
  golden: boolean;
  /** Who dropped it — used for the attachment/variety mechanic. */
  source: string;
  age = 0;
  bobPhase: number;
  /** Spawn pop-in scale, animates 0 -> 1. */
  spawn = 0;

  constructor(x: number, y: number, tier: number, golden: boolean, bobPhase: number, source: string) {
    this.x = x;
    this.y = y;
    this.tier = tier;
    this.golden = golden;
    this.source = source;
    this.bobPhase = bobPhase;
    this.radius = golden ? CONFIG.poop.baseRadius * 1.7 : CONFIG.poop.baseRadius + tier * 1.4;
  }

  /** True once it should be removed (faded out). */
  update(dt: number): boolean {
    this.age += dt;
    this.spawn = Math.min(1, this.spawn + dt * 6);
    // Golden poop lingers longer so it's chase-able.
    const life = this.golden ? CONFIG.poop.lifetime * 1.6 : CONFIG.poop.lifetime;
    return this.age >= life;
  }

  /** Fade alpha near end of life. */
  get alpha(): number {
    const life = this.golden ? CONFIG.poop.lifetime * 1.6 : CONFIG.poop.lifetime;
    const remaining = life - this.age;
    return remaining < 2 ? Math.max(0, remaining / 2) : 1;
  }
}
